// Global
import React from 'react';
import styles from './FeatureDecor.module.scss';
import clsx from 'clsx';

export const FeatureDecor = () => {
  return (
    <div className={styles.decor}>
      <svg
        className={clsx(styles.bottomFull, styles.overrideFillColor)}
        xmlns="http://www.w3.org/2000/svg"
        width="1800"
        height="494"
        fill="none"
      >
        <path
          d="M0 496.152H900H1800V69.1545C1800 69.1545 1648.75 7.66571 1450.62 0.666992C1252.5 -6.33173 1161.88 60.2821 846.109 60.2821C530.343 60.2821 395.625 -27.3279 0 48.3787V496.152Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
